import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"close\"><g fill-rule=\"nonzero\"><path d=\"M12.3.3l1.414 1.414-12 12L.3 12.3z\" /><path d=\"M13.714 12.3L12.3 13.714l-12-12L1.714.3z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol